export default {
  campagne: 'Nous campagnes',
  published: 'Publié le',
  archivio: 'Archives des actualités',
  notizieCorrelate: 'Actualités connexes',
  modalitaDusoVino: "Mode d'emploi <br /> des levures pour <i>vin</i>",
  modalitaDusoBirra: "Mode d'emploi <br /> des levures pour <i>bière</i>",
  buy: 'Acheter',
  richiediInfo: "Demande d'info",
  etichettaAmbientale: 'Étiquette environnementale',
  what: "Qu'est-ce que c'est",
  where: 'Où va',
  raccoltaPlastica: 'Collecte de plastique',
  disposizioni: 'Vérifiez les dispositions de votre commune',
  disposizioniInfo:
    'Produit pour usage professionnel œnologique conforme à: Reg. CEE/UE N°934/2019 et Codex OIV International',
  applicazioni: 'Applications',
  specificheTecniche: 'Spécifications techniques',
  preparazione: 'Préparation',
  scaricaScheda: 'Télécharger la fiche technique',
  scaricaSchedaPanificati: 'Fiche technique - Recettes',
  contenitore: 'Conteneur',
  tappo: 'Bouchon',
  sottotappo: 'Sous-bouchon',
  tappoFlacone: 'Bouchon de flacon',
  tappoTanica: 'Bouchon de bidon',
  sacchetto: 'Sac',
  vediNews: 'Archives des actualités',
  vediVideo: 'Toutes les vidéos',
  news: 'Actualités',
  videos: 'Vidéos',
  leggi: 'Lire la suite',
  indietro: 'Retour',
  seeAll: 'Voir tout',
  filtri: 'Filtres',
  approfondisci: 'Découvrir plus',
  prodotto: 'Aller au produit',
  cancellaFiltri: 'Effacer les filtres',
  modelTitle: 'Nos Atecnos: pionniers de la révolution de la levure',
  modelText:
    "En 2012, nous avons été les premiers à introduire sur le marché des levures en crème. Atecnos se distingue grâce à une méthodologie exclusive qui reproduit fidèlement les processus naturels de multiplication des levures. Nous obtenons une levure fraîche, d'une grande pureté, extrêmement réactive et prête à l'emploi qui permet une inoculation directe sur le moût.",
  iubendaCookiePolicyId: '25733370',
}
